// General
import React from 'react';

// Component
import ViewReceipt from '../../../components/siteadmin/ViewReceipt';

const ReceiptContainer = (props) => {

  const { data, title } = props;

  return <ViewReceipt data={data} title={title} />;
}

ReceiptContainer.propTypes = {
  data: PropTypes.object,
  title: PropTypes.string.isRequired
};

export default ReceiptContainer;

